export interface CanUserEditColumnTemplateArgs {
	canSaveAll: boolean;

	savedAll: boolean;
}
export function canUserEditColumnTemplate({
	canSaveAll,

	savedAll,
}: CanUserEditColumnTemplateArgs): boolean {
	if (savedAll && !canSaveAll) {
		return false;
	}

	return true;
}
